// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Space+Grotesk:wght@300..700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;@tailwind components;@tailwind utilities;/*
! tailwindcss v3.4.4 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}::before,
::after {
  --tw-content: '';
}/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Montserrat, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}/*
Remove the default font size and weight for headings.
*/h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}/*
Reset links to optimize for opt-in styling instead of opt-out.
*/a {
  color: inherit;
  text-decoration: inherit;
}/*
Add the correct font weight in Edge and Safari.
*/b,
strong {
  font-weight: bolder;
}/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}/*
Add the correct font size in all browsers.
*/small {
  font-size: 80%;
}/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}sub {
  bottom: -0.25em;
}sup {
  top: -0.5em;
}/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}/*
Remove the inheritance of text transform in Edge and Firefox.
*/button,
select {
  text-transform: none;
}/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}/*
Use the modern Firefox focus style for all focusable elements.
*/:-moz-focusring {
  outline: auto;
}/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/:-moz-ui-invalid {
  box-shadow: none;
}/*
Add the correct vertical alignment in Chrome and Firefox.
*/progress {
  vertical-align: baseline;
}/*
Correct the cursor style of increment and decrement buttons in Safari.
*/::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}/*
Remove the inner padding in Chrome and Safari on macOS.
*/::-webkit-search-decoration {
  -webkit-appearance: none;
}/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}/*
Add the correct display in Chrome and Safari.
*/summary {
  display: list-item;
}/*
Removes the default spacing and border for appropriate elements.
*/blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}fieldset {
  margin: 0;
  padding: 0;
}legend {
  padding: 0;
}ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}/*
Reset default styling for dialogs.
*/dialog {
  padding: 0;
}/*
Prevent resizing textareas horizontally by default.
*/textarea {
  resize: vertical;
}/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}/*
Set the default cursor for buttons.
*/button,
[role="button"] {
  cursor: pointer;
}/*
Make sure disabled buttons don't get the pointer cursor.
*/:disabled {
  cursor: default;
}/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/img,
video {
  max-width: 100%;
  height: auto;
}/* Make elements with the HTML hidden attribute stay hidden by default */[hidden] {
  display: none;
}:root{
  --inherit: inherit;
  --current: currentColor;
  --transparent: transparent;
  --black: #000;
  --white: #fff;
  --slate-50: #f8fafc;
  --slate-100: #f1f5f9;
  --slate-200: #e2e8f0;
  --slate-300: #cbd5e1;
  --slate-400: #94a3b8;
  --slate-500: #64748b;
  --slate-600: #475569;
  --slate-700: #334155;
  --slate-800: #1e293b;
  --slate-900: #0f172a;
  --slate-950: #020617;
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-300: #d1d5db;
  --gray-400: #9ca3af;
  --gray-500: #6b7280;
  --gray-600: #4b5563;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --gray-900: #111827;
  --gray-950: #030712;
  --zinc-50: #fafafa;
  --zinc-100: #f4f4f5;
  --zinc-200: #e4e4e7;
  --zinc-300: #d4d4d8;
  --zinc-400: #a1a1aa;
  --zinc-500: #71717a;
  --zinc-600: #52525b;
  --zinc-700: #3f3f46;
  --zinc-800: #27272a;
  --zinc-900: #18181b;
  --zinc-950: #09090b;
  --neutral-50: #fafafa;
  --neutral-100: #f5f5f5;
  --neutral-200: #e5e5e5;
  --neutral-300: #d4d4d4;
  --neutral-400: #a3a3a3;
  --neutral-500: #737373;
  --neutral-600: #525252;
  --neutral-700: #404040;
  --neutral-800: #262626;
  --neutral-900: #171717;
  --neutral-950: #0a0a0a;
  --stone-50: #fafaf9;
  --stone-100: #f5f5f4;
  --stone-200: #e7e5e4;
  --stone-300: #d6d3d1;
  --stone-400: #a8a29e;
  --stone-500: #78716c;
  --stone-600: #57534e;
  --stone-700: #44403c;
  --stone-800: #292524;
  --stone-900: #1c1917;
  --stone-950: #0c0a09;
  --red-50: #fef2f2;
  --red-100: #fee2e2;
  --red-200: #fecaca;
  --red-300: #fca5a5;
  --red-400: #f87171;
  --red-500: #ef4444;
  --red-600: #dc2626;
  --red-700: #b91c1c;
  --red-800: #991b1b;
  --red-900: #7f1d1d;
  --red-950: #450a0a;
  --orange-50: #fff7ed;
  --orange-100: #ffedd5;
  --orange-200: #fed7aa;
  --orange-300: #fdba74;
  --orange-400: #fb923c;
  --orange-500: #f97316;
  --orange-600: #ea580c;
  --orange-700: #c2410c;
  --orange-800: #9a3412;
  --orange-900: #7c2d12;
  --orange-950: #431407;
  --amber-50: #fffbeb;
  --amber-100: #fef3c7;
  --amber-200: #fde68a;
  --amber-300: #fcd34d;
  --amber-400: #fbbf24;
  --amber-500: #f59e0b;
  --amber-600: #d97706;
  --amber-700: #b45309;
  --amber-800: #92400e;
  --amber-900: #78350f;
  --amber-950: #451a03;
  --yellow-50: #fefce8;
  --yellow-100: #fef9c3;
  --yellow-200: #fef08a;
  --yellow-300: #fde047;
  --yellow-400: #facc15;
  --yellow-500: #eab308;
  --yellow-600: #ca8a04;
  --yellow-700: #a16207;
  --yellow-800: #854d0e;
  --yellow-900: #713f12;
  --yellow-950: #422006;
  --lime-50: #f7fee7;
  --lime-100: #ecfccb;
  --lime-200: #d9f99d;
  --lime-300: #bef264;
  --lime-400: #a3e635;
  --lime-500: #84cc16;
  --lime-600: #65a30d;
  --lime-700: #4d7c0f;
  --lime-800: #3f6212;
  --lime-900: #365314;
  --lime-950: #1a2e05;
  --green-50: #f0fdf4;
  --green-100: #dcfce7;
  --green-200: #bbf7d0;
  --green-300: #86efac;
  --green-400: #4ade80;
  --green-500: #22c55e;
  --green-600: #16a34a;
  --green-700: #15803d;
  --green-800: #166534;
  --green-900: #14532d;
  --green-950: #052e16;
  --emerald-50: #ecfdf5;
  --emerald-100: #d1fae5;
  --emerald-200: #a7f3d0;
  --emerald-300: #6ee7b7;
  --emerald-400: #34d399;
  --emerald-500: #10b981;
  --emerald-600: #059669;
  --emerald-700: #047857;
  --emerald-800: #065f46;
  --emerald-900: #064e3b;
  --emerald-950: #022c22;
  --teal-50: #f0fdfa;
  --teal-100: #ccfbf1;
  --teal-200: #99f6e4;
  --teal-300: #5eead4;
  --teal-400: #2dd4bf;
  --teal-500: #14b8a6;
  --teal-600: #0d9488;
  --teal-700: #0f766e;
  --teal-800: #115e59;
  --teal-900: #134e4a;
  --teal-950: #042f2e;
  --cyan-50: #ecfeff;
  --cyan-100: #cffafe;
  --cyan-200: #a5f3fc;
  --cyan-300: #67e8f9;
  --cyan-400: #22d3ee;
  --cyan-500: #06b6d4;
  --cyan-600: #0891b2;
  --cyan-700: #0e7490;
  --cyan-800: #155e75;
  --cyan-900: #164e63;
  --cyan-950: #083344;
  --sky-50: #f0f9ff;
  --sky-100: #e0f2fe;
  --sky-200: #bae6fd;
  --sky-300: #7dd3fc;
  --sky-400: #38bdf8;
  --sky-500: #0ea5e9;
  --sky-600: #0284c7;
  --sky-700: #0369a1;
  --sky-800: #075985;
  --sky-900: #0c4a6e;
  --sky-950: #082f49;
  --blue-50: #eff6ff;
  --blue-100: #dbeafe;
  --blue-200: #bfdbfe;
  --blue-300: #93c5fd;
  --blue-400: #60a5fa;
  --blue-500: #3b82f6;
  --blue-600: #2563eb;
  --blue-700: #1d4ed8;
  --blue-800: #1e40af;
  --blue-900: #1e3a8a;
  --blue-950: #172554;
  --indigo-50: #eef2ff;
  --indigo-100: #e0e7ff;
  --indigo-200: #c7d2fe;
  --indigo-300: #a5b4fc;
  --indigo-400: #818cf8;
  --indigo-500: #6366f1;
  --indigo-600: #4f46e5;
  --indigo-700: #4338ca;
  --indigo-800: #3730a3;
  --indigo-900: #312e81;
  --indigo-950: #1e1b4b;
  --violet-50: #f5f3ff;
  --violet-100: #ede9fe;
  --violet-200: #ddd6fe;
  --violet-300: #c4b5fd;
  --violet-400: #a78bfa;
  --violet-500: #8b5cf6;
  --violet-600: #7c3aed;
  --violet-700: #6d28d9;
  --violet-800: #5b21b6;
  --violet-900: #4c1d95;
  --violet-950: #2e1065;
  --purple-50: #faf5ff;
  --purple-100: #f3e8ff;
  --purple-200: #e9d5ff;
  --purple-300: #d8b4fe;
  --purple-400: #c084fc;
  --purple-500: #a855f7;
  --purple-600: #9333ea;
  --purple-700: #7e22ce;
  --purple-800: #6b21a8;
  --purple-900: #581c87;
  --purple-950: #3b0764;
  --fuchsia-50: #fdf4ff;
  --fuchsia-100: #fae8ff;
  --fuchsia-200: #f5d0fe;
  --fuchsia-300: #f0abfc;
  --fuchsia-400: #e879f9;
  --fuchsia-500: #d946ef;
  --fuchsia-600: #c026d3;
  --fuchsia-700: #a21caf;
  --fuchsia-800: #86198f;
  --fuchsia-900: #701a75;
  --fuchsia-950: #4a044e;
  --pink-50: #fdf2f8;
  --pink-100: #fce7f3;
  --pink-200: #fbcfe8;
  --pink-300: #f9a8d4;
  --pink-400: #f472b6;
  --pink-500: #ec4899;
  --pink-600: #db2777;
  --pink-700: #be185d;
  --pink-800: #9d174d;
  --pink-900: #831843;
  --pink-950: #500724;
  --rose-50: #fff1f2;
  --rose-100: #ffe4e6;
  --rose-200: #fecdd3;
  --rose-300: #fda4af;
  --rose-400: #fb7185;
  --rose-500: #f43f5e;
  --rose-600: #e11d48;
  --rose-700: #be123c;
  --rose-800: #9f1239;
  --rose-900: #881337;
  --rose-950: #4c0519;
  --greenGR: #62e6ce;
  --blueGR: #62afe6;
  --lavenderGR: #c4b0fc;
  --blackGR: #010102;
  --greyGR: #1E1C28;
  --darkGrayGR: #202020;
}::-webkit-scrollbar{width:8px}::-webkit-scrollbar-track{background:#111}::-webkit-scrollbar-thumb{background-color:var(--blueGR)}::-webkit-scrollbar-thumb:hover{background:#444}*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}.container{
  width: 100%;
}@media (min-width: 640px){.container{
    max-width: 640px;
  }
}@media (min-width: 768px){.container{
    max-width: 768px;
  }
}@media (min-width: 1024px){.container{
    max-width: 1024px;
  }
}@media (min-width: 1280px){.container{
    max-width: 1280px;
  }
}@media (min-width: 1536px){.container{
    max-width: 1536px;
  }
}.visible{
  visibility: visible;
}.fixed{
  position: fixed;
}.absolute{
  position: absolute;
}.relative{
  position: relative;
}.inset-0{
  inset: 0px;
}.inset-\\[2px\\]{
  inset: 2px;
}.bottom-0{
  bottom: 0px;
}.left-0{
  left: 0px;
}.left-1\\/2{
  left: 50%;
}.top-0{
  top: 0px;
}.top-\\[1px\\]{
  top: 1px;
}.top-\\[60\\%\\]{
  top: 60%;
}.top-full{
  top: 100%;
}.z-0{
  z-index: 0;
}.z-10{
  z-index: 10;
}.z-20{
  z-index: 20;
}.z-50{
  z-index: 50;
}.z-\\[1\\]{
  z-index: 1;
}.m-0{
  margin: 0px;
}.m-40{
  margin: 10rem;
}.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}.mx-auto{
  margin-left: auto;
  margin-right: auto;
}.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}.mb-4{
  margin-bottom: 1rem;
}.mb-5{
  margin-bottom: 1.25rem;
}.mb-8{
  margin-bottom: 2rem;
}.ml-1{
  margin-left: 0.25rem;
}.ml-2{
  margin-left: 0.5rem;
}.mt-1{
  margin-top: 0.25rem;
}.mt-1\\.5{
  margin-top: 0.375rem;
}.mt-10{
  margin-top: 2.5rem;
}.mt-28{
  margin-top: 7rem;
}.mt-auto{
  margin-top: auto;
}.block{
  display: block;
}.flex{
  display: flex;
}.inline-flex{
  display: inline-flex;
}.grid{
  display: grid;
}.contents{
  display: contents;
}.hidden{
  display: none;
}.h-1{
  height: 0.25rem;
}.h-1\\.5{
  height: 0.375rem;
}.h-1\\/6{
  height: 16.666667%;
}.h-10{
  height: 2.5rem;
}.h-11{
  height: 2.75rem;
}.h-12{
  height: 3rem;
}.h-2{
  height: 0.5rem;
}.h-20{
  height: 5rem;
}.h-28{
  height: 7rem;
}.h-3{
  height: 0.75rem;
}.h-3\\/4{
  height: 75%;
}.h-32{
  height: 8rem;
}.h-6{
  height: 1.5rem;
}.h-9{
  height: 2.25rem;
}.h-\\[90px\\]{
  height: 90px;
}.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}.h-auto{
  height: auto;
}.h-full{
  height: 100%;
}.h-min{
  height: -moz-min-content;
  height: min-content;
}.h-screen{
  height: 100vh;
}.max-h-\\[120px\\]{
  max-height: 120px;
}.min-h-screen{
  min-height: 100vh;
}.w-1\\/6{
  width: 16.666667%;
}.w-10{
  width: 2.5rem;
}.w-2{
  width: 0.5rem;
}.w-2\\/3{
  width: 66.666667%;
}.w-3{
  width: 0.75rem;
}.w-3\\/4{
  width: 75%;
}.w-32{
  width: 8rem;
}.w-8\\/12{
  width: 66.666667%;
}.w-auto{
  width: auto;
}.w-fit{
  width: -moz-fit-content;
  width: fit-content;
}.w-full{
  width: 100%;
}.w-max{
  width: -moz-max-content;
  width: max-content;
}.max-w-2xl{
  max-width: 42rem;
}.max-w-5xl{
  max-width: 64rem;
}.max-w-max{
  max-width: -moz-max-content;
  max-width: max-content;
}.max-w-md{
  max-width: 28rem;
}.flex-1{
  flex: 1 1 0%;
}.flex-none{
  flex: none;
}.flex-grow{
  flex-grow: 1;
}.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.scale-\\[1\\.2\\]{
  --tw-scale-x: 1.2;
  --tw-scale-y: 1.2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.animate-\\[wiggle_1s_ease-in-out_infinite\\]{
  animation: wiggle 1s ease-in-out infinite;
}@keyframes spin{to{
    transform: rotate(360deg);
  }0%, 100%{
    transform: rotate(0deg);
  }100%{
    transform: rotate(360deg);
  }
}.animate-spin{
  animation: spin 1s linear infinite;
}.cursor-not-allowed{
  cursor: not-allowed;
}.list-inside{
  list-style-position: inside;
}.list-disc{
  list-style-type: disc;
}.list-none{
  list-style-type: none;
}.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}.flex-col{
  flex-direction: column;
}.flex-wrap{
  flex-wrap: wrap;
}.flex-nowrap{
  flex-wrap: nowrap;
}.content-center{
  align-content: center;
}.items-start{
  align-items: flex-start;
}.items-end{
  align-items: flex-end;
}.items-center{
  align-items: center;
}.justify-start{
  justify-content: flex-start;
}.justify-end{
  justify-content: flex-end;
}.justify-center{
  justify-content: center;
}.justify-between{
  justify-content: space-between;
}.gap-10{
  gap: 2.5rem;
}.gap-x-\\[10px\\]{
  -moz-column-gap: 10px;
       column-gap: 10px;
}.gap-x-\\[1px\\]{
  -moz-column-gap: 1px;
       column-gap: 1px;
}.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}.overflow-hidden{
  overflow: hidden;
}.overflow-visible{
  overflow: visible;
}.whitespace-nowrap{
  white-space: nowrap;
}.rounded-2xl{
  border-radius: 1rem;
}.rounded-3xl{
  border-radius: 1.5rem;
}.rounded-\\[100px\\]{
  border-radius: 100px;
}.rounded-\\[inherit\\]{
  border-radius: inherit;
}.rounded-full{
  border-radius: 9999px;
}.rounded-lg{
  border-radius: 0.5rem;
}.rounded-md{
  border-radius: 0.375rem;
}.rounded-tl-sm{
  border-top-left-radius: 0.125rem;
}.border{
  border-width: 1px;
}.border-2{
  border-width: 2px;
}.border-8{
  border-width: 8px;
}.border-none{
  border-style: none;
}.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}.border-blueGR{
  --tw-border-opacity: 1;
  border-color: rgb(98 175 230 / var(--tw-border-opacity));
}.border-darkGrayGR{
  --tw-border-opacity: 1;
  border-color: rgb(32 32 32 / var(--tw-border-opacity));
}.border-greenGR{
  --tw-border-opacity: 1;
  border-color: rgb(98 230 206 / var(--tw-border-opacity));
}.border-lavenderGR{
  --tw-border-opacity: 1;
  border-color: rgb(196 176 252 / var(--tw-border-opacity));
}.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}.border-t-lavenderGR{
  --tw-border-opacity: 1;
  border-top-color: rgb(196 176 252 / var(--tw-border-opacity));
}.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}.bg-blackGR{
  --tw-bg-opacity: 1;
  background-color: rgb(1 1 2 / var(--tw-bg-opacity));
}.bg-darkGrayGR{
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 32 / var(--tw-bg-opacity));
}.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}.bg-greenGR{
  --tw-bg-opacity: 1;
  background-color: rgb(98 230 206 / var(--tw-bg-opacity));
}.bg-greyGR{
  --tw-bg-opacity: 1;
  background-color: rgb(30 28 40 / var(--tw-bg-opacity));
}.bg-lavenderGR{
  --tw-bg-opacity: 1;
  background-color: rgb(196 176 252 / var(--tw-bg-opacity));
}.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}.decoration-clone{
  -webkit-box-decoration-break: clone;
          box-decoration-break: clone;
}.p-1{
  padding: 0.25rem;
}.p-2{
  padding: 0.5rem;
}.p-4{
  padding: 1rem;
}.p-5{
  padding: 1.25rem;
}.p-6{
  padding: 1.5rem;
}.p-8{
  padding: 2rem;
}.p-\\[22px\\]{
  padding: 22px;
}.p-px{
  padding: 1px;
}.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}.pb-12{
  padding-bottom: 3rem;
}.pt-0{
  padding-top: 0px;
}.pt-32{
  padding-top: 8rem;
}.pt-40{
  padding-top: 10rem;
}.pt-7{
  padding-top: 1.75rem;
}.text-left{
  text-align: left;
}.text-center{
  text-align: center;
}.font-grotesk{
  font-family: Space Grotesk, sans-serif;
}.font-sans{
  font-family: Montserrat, sans-serif;
}.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}.text-5xl{
  font-size: 3rem;
  line-height: 1;
}.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}.text-base\\/6{
  font-size: 1rem;
  line-height: 1.5rem;
}.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}.font-medium{
  font-weight: 500;
}.font-semibold{
  font-weight: 600;
}.font-thin{
  font-weight: 100;
}.leading-none{
  line-height: 1;
}.leading-tight{
  line-height: 1.25;
}.tracking-\\[-0\\.015em\\]{
  letter-spacing: -0.015em;
}.tracking-tight{
  letter-spacing: -0.025em;
}.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}.text-blueGR{
  --tw-text-opacity: 1;
  color: rgb(98 175 230 / var(--tw-text-opacity));
}.text-greenGR{
  --tw-text-opacity: 1;
  color: rgb(98 230 206 / var(--tw-text-opacity));
}.text-lavenderGR{
  --tw-text-opacity: 1;
  color: rgb(196 176 252 / var(--tw-text-opacity));
}.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}.underline{
  text-decoration-line: underline;
}.underline-offset-4{
  text-underline-offset: 4px;
}.opacity-0{
  opacity: 0;
}.opacity-10{
  opacity: 0.1;
}.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}.outline{
  outline-style: solid;
}.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}.duration-200{
  transition-duration: 200ms;
}.duration-300{
  transition-duration: 300ms;
}.duration-500{
  transition-duration: 500ms;
}.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}.\\[mask-image\\:radial-gradient\\(\\#fff\\2c transparent\\2c 75\\%\\)\\]{
  -webkit-mask-image: radial-gradient(#fff,transparent,75%);
          mask-image: radial-gradient(#fff,transparent,75%);
}.btn{
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(98 230 206 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0px;
  padding-bottom: 0px;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}.btn:hover{
  background-color: rgb(98 230 206 / 0.9);
}.gitResumeLanding{
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(98 230 206 / var(--tw-bg-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-family: Montserrat, sans-serif;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}.form{display:flex;flex-direction:row;justify-content:center;align-items:center;gap:10px;max-width:600px;background:#32353c;padding:8px;border-radius:10px;box-shadow:0 4px 6px rgba(0,0,0,.3);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);color:#fff}.form input{width:100%;padding:10px;border-radius:10px;border:none}body{font-family:"CustomFont",sans-serif;overflow-y:scroll}.custom-padding{padding:0px 10px;height:20px;line-height:15px !important;margin:auto}.icon{width:12px;height:12px}.lang-color{width:10px;height:10px;border-radius:69px;border:1px solid #fff}.hover\\:border-lavenderGR:hover{
  --tw-border-opacity: 1;
  border-color: rgb(196 176 252 / var(--tw-border-opacity));
}.hover\\:bg-black\\/10:hover{
  background-color: rgb(0 0 0 / 0.1);
}.hover\\:bg-greenGR\\/90:hover{
  background-color: rgb(98 230 206 / 0.9);
}.hover\\:bg-lavenderGR:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(196 176 252 / var(--tw-bg-opacity));
}.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}.hover\\:text-lavenderGR:hover{
  --tw-text-opacity: 1;
  color: rgb(196 176 252 / var(--tw-text-opacity));
}.hover\\:underline:hover{
  text-decoration-line: underline;
}.focus\\:border-greenGR:focus{
  --tw-border-opacity: 1;
  border-color: rgb(98 230 206 / var(--tw-border-opacity));
}.focus\\:bg-blueGR:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(98 175 230 / var(--tw-bg-opacity));
}.focus\\:bg-lavenderGR:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(196 176 252 / var(--tw-bg-opacity));
}.focus\\:text-black:focus{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}.active\\:border-greenGR:active{
  --tw-border-opacity: 1;
  border-color: rgb(98 230 206 / var(--tw-border-opacity));
}.active\\:bg-lavenderGR:active{
  --tw-bg-opacity: 1;
  background-color: rgb(196 176 252 / var(--tw-bg-opacity));
}.active\\:text-black:active{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}.data-\\[state\\=open\\]\\:scale-100[data-state=open]{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.data-\\[state\\=open\\]\\:opacity-100[data-state=open]{
  opacity: 1;
}.group[data-state=open] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}.dark\\:bg-black:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}.dark\\:bg-white\\/20:is(.dark *){
  background-color: rgb(255 255 255 / 0.2);
}.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}@media (min-width: 640px){.sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }.sm\\:w-\\[300px\\]{
    width: 300px;
  }.sm\\:grid-flow-col{
    grid-auto-flow: column;
  }.sm\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }.sm\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }.sm\\:rounded-2xl{
    border-radius: 1rem;
  }.sm\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}@media (min-width: 768px){.md\\:absolute{
    position: absolute;
  }.md\\:mb-0{
    margin-bottom: 0px;
  }.md\\:block{
    display: block;
  }.md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }.md\\:w-auto{
    width: auto;
  }.md\\:flex-col{
    flex-direction: column;
  }.md\\:items-center{
    align-items: center;
  }.md\\:text-left{
    text-align: left;
  }.md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}@media (min-width: 1024px){.lg\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/tailwindcss/base.css","webpack://./client/stylesheets/scss/styles.scss","webpack://./client/stylesheets/scss/main.scss"],"names":[],"mappings":"AAAA,cAAA,CAAA,oBAAA,CAAA,mBAAA,CAAA;;CAAA,CAAA;;;CAAA,CAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA,CAAA;;EAAA,gBAAA;AAAA,CAAA;;;;;;;;CAAA,CAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,cAAA;KAAA,WAAA,EAAA,MAAA;EAAA,mCAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA,CAAA;;;CAAA,CAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA,CAAA;;;;CAAA,CAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA,CAAA;;CAAA,CAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,cAAA;EAAA,wBAAA;AAAA,CAAA;;CAAA,CAAA;;EAAA,mBAAA;AAAA,CAAA;;;;;CAAA,CAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,cAAA;AAAA,CAAA;;CAAA,CAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA,CAAA;EAAA,eAAA;AAAA,CAAA;EAAA,WAAA;AAAA,CAAA;;;;CAAA,CAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA,CAAA;;;;CAAA,CAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA,CAAA;;CAAA,CAAA;;EAAA,oBAAA;AAAA,CAAA;;;CAAA,CAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,aAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,gBAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,wBAAA;AAAA,CAAA;;CAAA,CAAA;;EAAA,YAAA;AAAA,CAAA;;;CAAA,CAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,wBAAA;AAAA,CAAA;;;CAAA,CAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,kBAAA;AAAA,CAAA;;CAAA,CAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA,CAAA;EAAA,SAAA;EAAA,UAAA;AAAA,CAAA;EAAA,UAAA;AAAA,CAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,UAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,gBAAA;AAAA,CAAA;;;CAAA,CAAA;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA,CAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA,CAAA;;CAAA,CAAA;;EAAA,eAAA;AAAA,CAAA;;CAAA,CAAA;EAAA,eAAA;AAAA,CAAA;;;;CAAA,CAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA,CAAA;;CAAA,CAAA;;EAAA,eAAA;EAAA,YAAA;AAAA,CAAA,wEAAA,CAAA;EAAA,aAAA;AAAA,CAAA;EAAA,kBAAA;EAAA,uBAAA;EAAA,0BAAA;EAAA,aAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA;AAAA,CAAA,oBAAA,SAAA,CAAA,0BAAA,eAAA,CAAA,0BAAA,8BAAA,CAAA,gCAAA,eAAA,CAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA,0BAAA;IAAA;EAAA;AAAA,CAAA,0BAAA;IAAA;EAAA;AAAA,CAAA,2BAAA;IAAA;EAAA;AAAA,CAAA,2BAAA;IAAA;EAAA;AAAA,CAAA,2BAAA;IAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,wBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,2BAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA,gBAAA;IAAA;EAAA,CAAA;IAAA;EAAA,CAAA;IAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,qBAAA;OAAA;AAAA,CAAA;EAAA,oBAAA;OAAA;AAAA,CAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA,gEAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,sBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,mCAAA;UAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,eAAA;EAAA;AAAA,CAAA;EAAA,eAAA;EAAA;AAAA,CAAA;EAAA,eAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA,CAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA;AAAA,CAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA,CAAA;EAAA,8BAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,6BAAA;EAAA,+QAAA;UAAA;AAAA,CAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA,CAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA,CAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,yDAAA;UAAA;AAAA,CC8CE;EAAA,uBAAA;EAAA,kBAAA;EAAA,wDAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAKA;EAAA,uBAAA;EAAA,kBAAA;EAAA,wDAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,uBAAA;EAAA,mCAAA;EAAA,oBAAA;EAAA;AAAA,CA4DF,MACE,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,kBAAA,CACA,QAAA,CACA,eAAA,CACA,kBAAA,CACA,WAAA,CACA,kBAAA,CACA,mCAAA,CACA,kCAAA,CAAA,0BAAA,CACA,UAAA,CAEA,YACE,UAAA,CACA,YAAA,CACA,kBAAA,CACA,WAAA,CCvHJ,KACE,mCAAA,CACA,iBAAA,CAGF,gBACE,gBAAA,CACA,WAAA,CACA,2BAAA,CACA,WAAA,CAGF,MACE,UAAA,CACA,WAAA,CAGF,YACE,UAAA,CACA,WAAA,CACA,kBAAA,CACA,qBAAA,CA1BM;EAAA,sBA0BN;EA1BM;AA0BN,CA1BM;EAAA;AA0BN,CA1BM;EAAA;AA0BN,CA1BM;EAAA,kBA0BN;EA1BM;AA0BN,CA1BM;EAAA,oBA0BN;EA1BM;AA0BN,CA1BM;EAAA,oBA0BN;EA1BM;AA0BN,CA1BM;EAAA;AA0BN,CA1BM;EAAA,sBA0BN;EA1BM;AA0BN,CA1BM;EAAA,kBA0BN;EA1BM;AA0BN,CA1BM;EAAA,kBA0BN;EA1BM;AA0BN,CA1BM;EAAA,oBA0BN;EA1BM;AA0BN,CA1BM;EAAA,8BA0BN;EA1BM;AA0BN,CA1BM;EAAA,8BA0BN;EA1BM;AA0BN,CA1BM;EAAA,2GA0BN;EA1BM,yGA0BN;EA1BM;AA0BN,CA1BM;EAAA;AA0BN,CA1BM;EAAA,sBA0BN;EA1BM;AA0BN,CA1BM;EAAA,kBA0BN;EA1BM;AA0BN,CA1BM;EAAA,oBA0BN;EA1BM;AA0BN,CA1BM;EAAA;AA0BN,CA1BM;EAAA;AA0BN,CA1BM;EAAA,eA0BN;EA1BM,eA0BN;EA1BM;AA0BN,CA1BM;EAAA;AA0BN,CA1BM;EAAA,mBA0BN;EA1BM;AA0BN,CA1BM;EAAA,kBA0BN;EA1BM;AA0BN,CA1BM;EAAA;AA0BN,CA1BM;EAAA,oBA0BN;EA1BM;AA0BN,CA1BM,0BAAA;IAAA,gBA0BN;IA1BM;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA,oBA0BN;IA1BM;EA0BN;AAAA,CA1BM,0BAAA;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA;EA0BN,CA1BM;IAAA,kBA0BN;IA1BM;EA0BN;AAAA,CA1BM,2BAAA;IAAA,iBA0BN;IA1BM;EA0BN;AAAA","sourcesContent":["@tailwind base;\n","@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n// some scrollbar coloring. can be changed.\n@layer base {\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: #111111;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: var(--blueGR);\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background: #444444;\n  }\n}\n\n\n\n// body {\n//   @apply flex flex-col min-h-screen bg-gradient-to-b from-blue-400 to-indigo-600;\n//   vertical-align: middle;\n//   align-items: center;\n//   width: 100vw;\n// }\n\n// .entry {\n//   @apply max-w-md w-full bg-white shadow-lg rounded-lg p-8;\n// }\n\n// h1 {\n//   @apply text-3xl font-semibold mb-6;\n// }\n\n// p {\n//   @apply text-gray-600 mb-6;\n// }\n\n.btn {\n  // @apply bg-indigo-700 hover:bg-indigo-900 text-blue-300 px-4 py-0 rounded-md;\n  @apply bg-greenGR hover:bg-greenGR/90 text-black px-4 py-0 rounded-md;\n\n}\n\n.gitResumeLanding {\n  @apply  bg-greenGR text-black px-3 py-3 font-sans rounded-md;\n\n}\n\n// html {\n//   scroll-behavior: smooth;\n// }\n\n// .documentation {\n//   max-width: 1150px;\n//   margin: 0 auto;\n// }\n\n// .section {\n//   margin-top: 40px;\n// }\n\n// .section h2 {\n//   color: #ffffff;\n//   font-size: 24px;\n//   margin-bottom: 10px;\n// }\n\n// .section p {\n//   margin-top: 5px;\n//   color: #ffffff;\n// }\n\n// code {\n//   text-align: left;\n//   padding: 10px 30px !important;\n//   border-radius: 10px;\n//   position: relative;\n\n//   &::after {\n//     content: \"SCSS\";\n//     padding: 3px 5px 2px;\n//     position: absolute;\n//     top: 0;\n//     right: 0;\n//     background: #383d49;\n//     border-bottom-left-radius: 10px;\n//   }\n// }\n\n// .nav {\n//   display: flex;\n//   flex-direction: column;\n//   justify-content: center;\n//   padding: 10px 0;\n//   gap: 10px;\n// }\n\n// .nav a {\n//   color: #ffffff;\n//   margin: 0 10px;\n//   font-weight: bold;\n//   text-decoration: underline;\n// }\n\n.form {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  max-width: 600px;\n  background: #32353c;\n  padding: 8px;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(10px);\n  color: #ffffff;\n\n  input {\n    width: 100%;\n    padding: 10px;\n    border-radius: 10px;\n    border: none;\n  }\n}\n","@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n@import \"./styles\";\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Space+Grotesk:wght@300..700&display=swap');\n\n\n// KG-2024-06-05_11-12-PM: lets move these to styles.scss for consistency?\nbody {\n  font-family: 'CustomFont', sans-serif;\n  overflow-y: scroll; // Always show the scrollbar (area), that way items dont shift when the scrollbar appears.\n}\n\n.custom-padding {\n  padding: 0px 10px;\n  height: 20px;\n  line-height: 15px !important;\n  margin: auto;\n}\n\n.icon {\n  width: 12px;\n  height: 12px;\n}\n\n.lang-color {\n  width: 10px;\n  height: 10px;\n  border-radius: 69px;\n  border: 1px solid #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
